import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { defaultConfig } from '../types/appConfig';
export const ConfigContext = React.createContext(defaultConfig);
export function ConfigProvider({ value, children }) {
    return _jsx(ConfigContext.Provider, { value: value, children: children });
}
